import React, { ReactElement } from 'react';
import { ColumnInstance } from 'react-table';
import { Flex } from 'rebass/styled-components';

import { FloatLabelInput, ButtonGroup } from 'ui/patterns';

import Icon from 'assets/icons';

import { TableHeaderProps } from './addEditGlobalSectionType';
import FloatLabelSelect from 'ui/patterns/floatSelect';

export default function TableHeader(props: TableHeaderProps): ReactElement {
  const isBooleanColumn = props.column.id === 'Call taker can add to call';
  const addToCallOption = [
    { label: 'All', value: '' },
    { label: 'Yes', value: 'true' },
    { label: 'No', value: 'false' },
  ];
  const onChangeText = (value: string) => {
    props.headerUpdateCallBack &&
      props.headerUpdateCallBack({ columnId: props.column.id, value });
  };

  let sortedItem;
  if (props.multiSortedItem instanceof Array) {
    sortedItem = props.multiSortedItem.find(
      mItem => mItem.sortKey === props.column.id,
    );
  } else {
    sortedItem = props.multiSortedItem;
  }

  if (props.sortedItem) {
    sortedItem = props.sortedItem;
  }

  const onSortChange = () => {
    props.handleSortChange && props.handleSortChange(props.column.id);
  };

  return (
    <Flex>
      {isBooleanColumn ? (
        <FloatLabelSelect
          style={{ flexGrow: 1 }}
          label={props.column.id}
          value={
            (props.columnsSearch && props.columnsSearch[props.column.id]) || ''
          }
          onChange={onChangeText}
          options={addToCallOption}
        />
      ) : (
        <FloatLabelInput
          style={{ flexGrow: '1' }}
          label={props.column.id}
          onChangeText={onChangeText}
          value={
            (props.columnsSearch && props.columnsSearch[props.column.id]) || ''
          }
        />
      )}
      <ButtonGroup onClick={onSortChange}>
        {sortedItem?.sortKey !== props.column.id && <Icon.Sort title="Sort" />}
        {sortedItem?.sortKey === props.column.id &&
          sortedItem?.sortOrder === 'asc' && <Icon.SortUp title="Sort" />}
        {sortedItem?.sortKey === props.column.id &&
          sortedItem?.sortOrder === 'desc' && <Icon.SortDown title="Sort" />}
      </ButtonGroup>
    </Flex>
  );
}
